import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../../common_components/mdae-framework";
import { GET_IS_QA_REVIEW_ENABLED } from "../services/get-is-qa-review-enabled";
import {
  auditorReviewKeysOrder,
  qaReviewKeysOrder,
  coderReviewKeysOrder,
  completedCasesKeysOrder,
  defaultAuditorReviewCaseDataCountList,
  defaultCoderReviewCaseDataCountList,
  defaultCompletedCasesDataCountList,
  defaultQaReviewCaseDataCountList,
} from "../constant";
import { GET_CASES_SUMMARY } from "../services/get-cases-summary";

export const SET_MY_CASES_FORM_DATA = "SET_MY_CASES_FORM_DATA";

export const defaultMyCasesFormData = {
  myCasesDataFetchFilter: null,
  auditorReviewData: null,
  qaReviewData: null,
  coderReviewData: null,
  completedData: null,
  caseSummaryGridVisible: false,
  caseSummaryGridDataList: [],
};

const initialState = {
  isLoading: false,
  isQaReviewEnabled: null,
  myCasesFormData: defaultMyCasesFormData,
};

export default function(state = initialState, action: any) {
  let newState;
  switch (action.type) {
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_IS_QA_REVIEW_ENABLED)(action)) {
        return {
          ...state,
          isQaReviewEnabled: null,
          isLoading: true,
        };
      }
      if (isAsyncComplete(GET_IS_QA_REVIEW_ENABLED)(action)) {
        const response = action.response;
        return {
          ...state,
          isQaReviewEnabled: response,
          isLoading: false,
        };
      }

      if (isAsyncOperation(GET_CASES_SUMMARY)(action)) {
        return {
          ...state,
          myCasesFormData: {
            ...state.myCasesFormData,
          },
        };
      }
      if (isAsyncComplete(GET_CASES_SUMMARY)(action)) {
        const response = action.response;
        let sortedAuditorReviewData = response?.auditorReviewData;
        if (sortedAuditorReviewData?.length > 0) {
          sortedAuditorReviewData = [...sortedAuditorReviewData].sort(
            (a, b) =>
              auditorReviewKeysOrder.indexOf(a.key) -
              auditorReviewKeysOrder.indexOf(b.key),
          );
        }
        let sortedQaReviewData = response?.qaReviewData;
        if (sortedQaReviewData?.length > 0) {
          sortedQaReviewData = [...sortedQaReviewData].sort(
            (a, b) =>
              qaReviewKeysOrder.indexOf(a.key) -
              qaReviewKeysOrder.indexOf(b.key),
          );
        }
        let sortedCoderReviewData = response?.coderReviewData;
        if (sortedCoderReviewData?.length > 0) {
          sortedCoderReviewData = [...sortedCoderReviewData].sort(
            (a, b) =>
              coderReviewKeysOrder.indexOf(a.key) -
              coderReviewKeysOrder.indexOf(b.key),
          );
        }
        let sortedCompletedData = response?.completedData;
        if (sortedCompletedData?.length > 0) {
          sortedCompletedData = [...sortedCompletedData].sort(
            (a, b) =>
              completedCasesKeysOrder.indexOf(a.key) -
              completedCasesKeysOrder.indexOf(b.key),
          );
        }
        return {
          ...state,
          myCasesFormData: {
            ...state.myCasesFormData,
            auditorReviewData:
              sortedAuditorReviewData?.length > 0
                ? sortedAuditorReviewData
                : defaultAuditorReviewCaseDataCountList,
            qaReviewData:
              sortedQaReviewData?.length > 0
                ? sortedQaReviewData
                : defaultQaReviewCaseDataCountList,
            coderReviewData:
              sortedCoderReviewData?.length > 0
                ? sortedCoderReviewData
                : defaultCoderReviewCaseDataCountList,
            completedData:
              sortedCompletedData?.length > 0
                ? sortedCompletedData
                : defaultCompletedCasesDataCountList,
          },
        };
      }
      return state;

    case SET_MY_CASES_FORM_DATA:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = {
          ...newState,
          myCasesFormData: {
            ...newState.myCasesFormData,
            ...action.data.myCasesFormData,
          },
        };
      }
      return newState;
    default:
      return state;
  }
}
